import dayjs from 'dayjs'

export function getTimeAsDayjs(timeString: string | null | undefined) {
   if (!timeString) {
      return null
   }
   const [hour, minute] = timeString.split(':').map(Number)
   return dayjs().set('hour', hour).set('minute', minute)
}

export function formatRelativeTime(isoString: string) {
   const now = dayjs()
   const time = dayjs(isoString)
   const diffInSeconds = now.diff(time, 'second')

   if (diffInSeconds < 60) return `${diffInSeconds}s`
   if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m`
   if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}h`
   if (diffInSeconds < 2592000) return `${Math.floor(diffInSeconds / 86400)}d`
   return `${Math.floor(diffInSeconds / 2592000)}mo`
}
